export default __webpack_public_path__ + "static/vector-shape11-abb58b4f95260499761e74ec29e0a6cf.png";